import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Map = ({ onLoad, ...props }) => {
  useEffect(() => {
    if (onLoad) onLoad();
  }, [onLoad]);

  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1066"
    >
      <polygon
        data-floor="0"
        points="494 821 596 830 638 823 638 816.95 665 819 665 841.42 840 859 880 852 880 842.78 916 846 1049 815 1105 819 1167 804 1167 800.29 1214 786 1224.91 786 1266 776 1266 772.45 1280 772 1312 764 1312 759.9 1326 758 1326 793.75 1134 861 1134 870 916 942 494 883.25 494 821"
      />

      <polygon
        data-floor="1"
        points="494 821 596 830 638 823 638 816.95 665 819 665 841.42 840 859 880 852 880 842.78 916 846 1049 815 1105 819 1167 804 1167 800.29 1214 786 1224.91 786 1266 776 1266 772.45 1280 772 1312 764 1312 759.9 1326 758 1343 754 1343 723.31 1325 723 1325 701 1275 709 1265 710 1225 717 1212 717 1167 724 1167 730 1105 738 1050 737 918.5 755.38 879 753 847.96 758 665 748 665 740 637 738 592 741 497 736 496 774 488 774 488 816.32 494 816.6 494 821"
      />

      <polygon
        data-floor="2"
        points="492 736 497 736 592 741 637 738 665 740 665 748 759.54 753.17 847.96 758 879 753 918.5 755.38 1050 737 1105 738 1167 730 1167 724 1227.73 716.52 1265 710 1275 709 1304.72 704.24 1325 701 1337 699 1336 670 1323.79 670 1324 646 1197 649 1092 653 1049 653 914.5 656.71 879 656 834 656 666 654 640 653 608 653 497 653 497 691 488 691.13 488 727.21 492 727 492 736"
      />

      <polygon
        data-floor="3"
        points="497 653 538.07 653 608 653 640 653 758.36 655.1 838.68 656 879 656 914.5 656.71 1049 653 1092 653 1182.12 649.57 1251.74 647.71 1324 646 1338.53 646 1339 616 1322.11 616 1322 591 1273 585 1175 577 1106 568 1048.15 568 912.5 557.65 880.64 557.65 844 556 668 562 686 565 637 568 608 567 500 568 500 608 491 608 491 644 497 644 497 653"
      />

      <polygon
        data-floor="4"
        points="500 568 608 567 637 568 686 565 668 562 844 556 885.32 557.65 912.5 557.65 1048.15 568 1106 568 1175 577 1267.05 584.51 1322 591 1337 592 1337 561.38 1322 561 1322 539 1334.08 539 1272 524 1261 523 1155 501 1128 503 1120 499 1163 496 1103 483 1048 485 915.5 460.94 880 464 843 457 670 471 706 479 642 484 600 480 501 487 502.01 524.5 491 524.5 491 561.04 500 561 500 568"
      />

      <polygon
        data-floor="5"
        points="501 487 600 480 642 484 706 479 670 471 843 457 880 464 915.5 460.94 1048 485 1103 483 1163 496 1120 499 1128 503 1155 501 1261 523 1272 524 1334.08 539 1334.08 507.7 1320 506 1320 487 1336 485 1304 476 1304 472 1273 462 1259 460 1150 428 1126 429 1118 425 1164 420 1100 400 1048 403 917 366 880 370 845 359 671 381 712 391 644 402 603 394 504 407 504 442 496 442 496 483.49 501 484 501 487"
      />

      <polygon
        data-floor="6"
        points="504 407 603 394 644 402 712 391 671 381 845 359 880 370 917 366 1048 403 1100 400 1164 420 1118 425 1126 429 1150 428 1259 460 1273 462 1304 472 1304 476 1336 485 1336 456.07 1319 454 1319 447 1361 444 1316 425 1280 427 1280 418 1304 417 1270 402 1230 404 1222 401 1247 399 1134 354 1115 349 1160 343 1099 317 1048 322 916 270.93 881 276 844 261 672 291 709 304 645 318 605 308 506 326 506 361 496 361.36 496 402.13 504 402 504 407"
      />

      <polygon
        data-floor="7"
        points="506 326 605 308 645 318 709 304 672 291 844 261 881 276 916 270.93 1048 322 1099 317 1160 343 1115 349 1134 354 1247 399 1222 401 1230 404 1270 402 1304 417 1280 418 1280 427 1316 425 1361 444 1361 437.52 1356 435 1356 416 1320 400 1320 358 1360 354 1360 346 1314 319 1286 322 1280 317 1224 321 1176 296 1176 280 1152 271 1161 269 1160.66 261 1098 228 1078 229 915 146 852 159 844 158 673 195 673 207 606 218 504 237 506 281 499 281 499 318.39 505 319 506 326"
      />
    </svg>
  );
};

Map.propTypes = {
  onLoad: PropTypes.func.isRequired,
};

export default Map;
